// Our main CSS
import '../css/app.css'
import Alpine from 'alpinejs'
import Collapse from '@alpinejs/collapse'
import { registerMobileHeaderMenu } from './mobile-header-menu'
import { compareWidget } from './compare-widget'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import 'swiper/css'

Alpine.plugin(Collapse)
window.Alpine = Alpine

// Register Alpine components before Alpine.start()
registerMobileHeaderMenu(Alpine)
Alpine.data('compareWidget', compareWidget)

Alpine.data('productSlider', () => ({
    init() {
        const prevBtns = this.$el.querySelectorAll('.product-slider-prev')
        const nextBtns = this.$el.querySelectorAll('.product-slider-next')

        new Swiper(this.$refs.swiper, {
            modules: [Navigation],
            navigation: {
                prevEl: Array.from(prevBtns),
                nextEl: Array.from(nextBtns),
            },
            slidesPerView: 1.2,
            spaceBetween: 16,
            breakpoints: {
                640: { slidesPerView: 2.2, spaceBetween: 20 },
                1024: { slidesPerView: 3.2, spaceBetween: 24 },
                1280: { slidesPerView: 3.5, spaceBetween: 24 },
            },
        })
    },
}))

Alpine.data('productGridSlider', () => ({
    init() {
        const swiper = new Swiper(this.$refs.swiper, {
            modules: [Navigation],
            navigation: {
                prevEl: this.$refs.prev,
                nextEl: this.$refs.next,
                disabledClass: 'swiper-nav-hidden',
            },
            slidesPerView: 1.2,
            spaceBetween: 24,
            breakpoints: {
                640:  { slidesPerView: 2.2, spaceBetween: 24 },
                1024: { slidesPerView: 4.2, spaceBetween: 24 },
            },
        })
        // Hide prev arrow on init (at beginning); show once navigated forward.
        swiper.on('navigationShow', () => {})
    },
}))

Alpine.data('miniCartItem', (key, initialQty, initialTotal) => ({
    key,
    qty: initialQty,
    lineTotal: initialTotal,
    removed: false,
    loading: false,
    _ajaxUrl: '',
    _nonce: '',

    init() {
        const list = this.$el.closest('[data-mini-cart-nonce]')
        this._nonce   = list?.dataset.miniCartNonce ?? ''
        this._ajaxUrl = list?.dataset.ajaxUrl ?? '/wp-admin/admin-ajax.php'
    },

    async _update(newQty) {
        if (this.loading) return
        this.loading = true
        try {
            const body = new URLSearchParams({
                action: 'mini_cart_update_qty',
                nonce:  this._nonce,
                key:    this.key,
                qty:    newQty,
            })
            const res  = await fetch(this._ajaxUrl, { method: 'POST', body })
            const data = await res.json()
            if (data.success) {
                if (data.data.removed) {
                    this.removed = true
                } else {
                    this.qty       = newQty
                    this.lineTotal = data.data.line_total
                }
                document.querySelectorAll('[data-mini-cart-total]').forEach(el => {
                    el.textContent = data.data.cart_total
                })
                document.querySelectorAll('[data-cart-count]').forEach(el => {
                    el.textContent = data.data.cart_count
                })
            }
        } catch (e) {
            console.error('Mini cart update failed:', e)
        } finally {
            this.loading = false
        }
    },

    increment() { this._update(this.qty + 1) },
    decrement() { this._update(Math.max(0, this.qty - 1)) },
    remove()    { this._update(0) },
}))

// "Lägg i varukorg" CTA on product-page sliders (Tillbehör/Reservdelar): WooCommerce's
// own AJAX add-to-cart (wc-add-to-cart.js) already fires a jQuery `added_to_cart` event
// on document.body once the item is added and the mini-cart fragments (see woo-global.php)
// come back — forward it as a native window event so the mini-cart drawer (Alpine scope
// in site-header.php) can open itself instead of the default "Visa varukorg" text link
// (hidden via CSS, see resources/css/woocommerce/global.css).
if (window.jQuery) {
    window.jQuery(document.body).on('added_to_cart', () => {
        window.dispatchEvent(new CustomEvent('open-mini-cart'))
    })
}

Alpine.start()

// Regular (non-AJAX) add-to-cart reloads the page — woo-cart.php prints this marker
// on the page that follows so the drawer opens with the freshly rendered cart.
if (document.querySelector('[data-open-mini-cart]')) {
    window.dispatchEvent(new CustomEvent('open-mini-cart'))
}
